import { useCallback } from "react"
import { initializeErrors } from "../reducer/validationSlice"
import { useValidateRepeatableElement } from "./useValidateRepeatableElement"

export const useInitializeHeaderValidations = (tabName,fieldPattern) => {

    const repeatableValidationMethods=useValidateRepeatableElement(tabName,fieldPattern)
    
    const initHeaderTabValidation = useCallback(() => (dispatch, getState) => {
             const {validateError}=repeatableValidationMethods
            const errors=dispatch(validateError("actorReducer","paymentDetails","PAYMENT DETAILS"))
            dispatch(initializeErrors({headerTab:errors}))
    }, [repeatableValidationMethods])

   

    return { initHeaderTabValidation,repeatableValidationMethods }
}